import * as Vue from 'vue';
import * as components from './components'
import { ConstructorOptions, Components } from './types/types'

const LennocComponents = {
  install (LennocComponentLibrary : typeof Vue, options : ConstructorOptions) {
    for (const componentName in components as Components) {
      const component = components[componentName as keyof Components]
      options.appInstance.component(componentName, component)
    }
    if (options.spritepath) {
      LennocComponentLibrary.provide('libraryOptions', options)
    }
  }
}

export default LennocComponents.install